import '@angular/localize/init';
import 'reflect-metadata';
import 'core-js/stable';
import 'classlist.js'; // Run `npm install --save classlist.js`
import 'zone.js';
import 'proxy-polyfill/proxy.min.js';
import 'whatwg-fetch';
import 'first-input-delay';
require('../manifest.webapp');
